import React from 'react';
import { AgentResultResponse } from '@tools/ui/types/generated/graphql';
import {
  FlowIdText,
  PollInfo,
  StyledCheckIcon,
  StyledInlineSpinner,
  StyledMonoTag,
  TriggeredCard,
  TriggeredItem,
  TriggeredLabel,
} from './RiskAgentRunner.styled';

export type TriggerItem = {
  agentName: string;
  flowId: string;
};

type TriggeredStatusProps = {
  isFetching: boolean;
  isPolling: boolean;
  pollAttempts: number;
  pollIntervalMs: number;
  results: AgentResultResponse[];
  triggered: TriggerItem[];
};

const TriggeredStatus: React.FC<TriggeredStatusProps> = ({
  isFetching,
  isPolling,
  pollAttempts,
  pollIntervalMs,
  results,
  triggered,
}) => (
  <TriggeredCard>
    <TriggeredLabel>
      Triggered — polling for results
      {isFetching && <StyledInlineSpinner size="small" />}
      {!isPolling && results.length > 0 && <StyledCheckIcon onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
    </TriggeredLabel>
    {triggered.map((item) => (
      <TriggeredItem key={item.agentName}>
        <StyledMonoTag>{item.agentName}</StyledMonoTag>
        <FlowIdText>flow: {item.flowId}</FlowIdText>
      </TriggeredItem>
    ))}
    {pollAttempts > 0 && isPolling && (
      <PollInfo>
        Polled {pollAttempts}× · next check in {pollIntervalMs / 1000}s
      </PollInfo>
    )}
  </TriggeredCard>
);

export { TriggeredStatus };
